var map = {
	"./arcos/bg.png": 71964,
	"./iprovinay/bg.png": 69347,
	"./juarez/bg.png": 49093,
	"./migob/bg.png": 78456,
	"./navojoa/bg.png": 47290,
	"./nayarit/bg.png": 75232,
	"./oaxaca/bg.png": 24587,
	"./repuve/bg.png": 43311,
	"./tlajomulco/bg.png": 25400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98273;